import { FC } from 'react';
import { CallIntelTypes } from '@frontend/api-call-intel';
import { CheckListPopoverFilterSelector } from '@frontend/analytics-shared';
import { useTranslation } from '@frontend/i18n';
import { trackingIds } from '../../../../../tracking-ids';
import { FilterIcon } from '../../atoms/filter-icon';
import { useContactTypeFilterData } from './use-contact-type-filter-data';

export const ContactTypeFilterChip: FC<{ disabled?: boolean }> = ({ disabled }) => {
  const { value: selectedValues, defaultValue, contactTypeOptions, isLoading, onChange } = useContactTypeFilterData();
  const { t } = useTranslation('call-intelligence');

  const isDisabled = disabled || isLoading;

  return (
    <div data-testid='contact-type-filter-chip'>
      <CheckListPopoverFilterSelector<CallIntelTypes.ContactTypeFilterEnum>
        customStyles={{ chipDropdownFilter: { width: '100%' } }}
        defaultValue={defaultValue}
        label={t('Contact Type')}
        onChange={onChange}
        options={contactTypeOptions}
        renderIcon={(isFilterActive) => <FilterIcon name='contacts-small' isFilterActive={isFilterActive} />}
        trackingId={trackingIds.callIntel.contactTypesSelector}
        value={selectedValues}
        disabled={isDisabled}
      />
    </div>
  );
};
